import { render } from "./UploadMedia.vue?vue&type=template&id=c32ed94c&scoped=true"
import script from "./UploadMedia.vue?vue&type=script&lang=js"
export * from "./UploadMedia.vue?vue&type=script&lang=js"

import "./UploadMedia.vue?vue&type=style&index=0&id=c32ed94c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c32ed94c"]])

export default __exports__